import React, { useContext, useEffect, useState } from 'react';
import Select from 'react-select';
import { fetchAPIDataWhileSettingState } from '../../b2b-common/helpers';
import { LoginContext } from '../../../App';
import { fetchCategoriesData } from '../../../services/b2b-indicators-apiService';
import { use } from 'i18next';

const CategoriesSelector = ({ onSelectedCategory, ...props }) => {
    const { loginData } = useContext(LoginContext);
    const [categories, setCategories] = useState([]);

    const options = categories.map(category => ({
        value: category.measurementUnitCategoryId,
        label: category.measurementUnitCategoryName
    }));

    const getCategories = async () => {
        try {
            const categories = await fetchAPIDataWhileSettingState(fetchCategoriesData, [loginData.accessToken], null);
            //console.log('Categories:', categories);
            setCategories(categories);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    }

    useEffect(() => {
        if (categories.length === 0) {
            getCategories();
        }
    }, []);

    const handleChange = (selectedOption) => {
        const selectedCategory = categories.find(category => category.measurementUnitCategoryId === selectedOption.value);
        onSelectedCategory(selectedCategory);
    }

    return (
        (categories && categories.length > 0) && (
            <Select
                onChange={handleChange}
                options={options}
                {...props}
            />
        )
    );
};

export default CategoriesSelector;